

















import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { PAGE_NS, PageState } from '~/store/modules/shared/page/state'
import ViewWrapper from '~/components/shared/classified/view/ViewWrapper.vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import HeadService from '~/services/HeadService'
import { computed, defineComponent } from '@nuxtjs/composition-api'
import ConsentPrompt from '~/components/shared/consent/ConsentPrompt.vue'
import { useNamespacedStore } from '~/compositions/store'
import { getRouteMetaItem } from '~/utils/router'
import { ClassifiedViewVariant } from '~/models/classified/view/variant'
import { APP_NS, AppState } from '~/store/modules/shared/app/state'
import {
  UserAgentState,
  USER_AGENT_NS
} from '~/store/modules/shared/userAgent/state'
import { useDep } from '~/compositions/dependency-container'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import { preconnectLink } from '~/factories/head'
import { createPhotoUrlWithSize, jpgToWebp } from '~/utils/photos'

export default defineComponent({
  name: 'ClassifiedView',
  components: {
    ViewWrapper,
    ConsentPrompt,
    CBreadcrumbs
  },
  // Using asyncData here in favor of setup useFetch due to a nuxt composition-api bug with children pages
  asyncData({ store, route }) {
    const inMapRouteMeta = getRouteMetaItem(route, 'inMap')
    return store.dispatch(`${CLASSIFIED_VIEW_NS}/createClassifiedView`, {
      slugOrId: route.params.slugOrId,
      variant: inMapRouteMeta
        ? ClassifiedViewVariant.MAP
        : ClassifiedViewVariant.DEFAULT
    })
  },
  setup() {
    const { state: viewState } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )
    const { getters: pageGetters } = useNamespacedStore<PageState>(PAGE_NS)
    const { getters: appGetter } = useNamespacedStore<AppState>(APP_NS)
    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )
    const dealerSiteService = useDep(DealerSiteService)
    const isDealerSite = computed(() => dealerSiteService.routeIsOfDealerSite())

    const isCar = computed(() => appGetter('isCar'))
    const isMobile = computed(() => userAgentGetters('isMobile'))

    const breadcrumbs = computed(() => viewState.page?.breadcrumbs)
    const pageIsExplicitAndRequiresConsent = computed(() =>
      pageGetters('pageIsExplicitAndRequiresConsent')
    )

    return {
      breadcrumbs,
      pageIsExplicitAndRequiresConsent,
      isCar,
      isMobile,
      isDealerSite
    }
  },
  head() {
    const headService = this.$dep(HeadService)
    const { view: viewStore } = this.$store.state.classifieds

    const { page, refs } = viewStore
    const { title, metadata } = page

    const nativePhotos = viewStore.classified?.compactPhotos.native.photos

    const meta = [
      ...headService.formatBackendMeta(metadata),
      ...[headService.getRouteOgUrlMetaTag(this.$route.path)]
    ]

    const link = [preconnectLink(viewStore.seoUrl, true, 'canonical')]

    if (nativePhotos?.length) {
      const [firstPhoto] = nativePhotos
      const imgSrc = jpgToWebp(createPhotoUrlWithSize(firstPhoto.url, 'z'))

      link.push({
        rel: 'preload',
        href: imgSrc,
        as: 'image'
      })
    }

    return headService.createHead({
      title: title || refs?.title,
      meta,
      link
    })
  }
})
